import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router';
import DataIntegrationForm from './DataIntegrationForm';
import { createDataIntegrationApi } from './integrationApi';
import { setLeavePrompt } from '../manage-users/usersSlice';
import PageHeader from '../../components/PageHeader';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'react-bootstrap';

const NewDataIntegration = () => {
  const { t } = useTranslation();
  const orgId = useSelector((s) => s.users.user.usrOrgId);
  const history = useHistory();
  const dispatch = useDispatch();

  const handleSubmit = async (formData) => {
    const payload = {
      name: formData.name,
      dataType: formData.dataType,
      connectType: formData.connectType,
      hostname: formData.hostname,
      port: formData.port ? parseInt(formData.port, 10) : null,
      username: formData.username,
      password: formData.password,
      remoteDir: formData.remoteDir || null,
      activated: !!formData.activated,
      fieldMap: formData.fieldMap || [],
      dataExpectedFrequency: formData.dataExpectedFrequency || null,
      dataNotifyEnabled: !!formData.dataNotifyEnabled,
      notificationEmails: formData.notificationEmails || null,
    };

    try {
      await createDataIntegrationApi(orgId, payload);
      toast.success('New data integration is created');
      history.push('/admin/settings/data-integrations');
    } catch (err) {
      toast.error(err.message || 'Create failed');
      dispatch(setLeavePrompt(true));
    }
  };

  const handleCancel = () => history.push('/admin/settings/data-integrations');

  return (
    <Container fluid>
      <Row>
        <Col>
          <PageHeader title={t('Create Data Integration')} enableBackButton />
        </Col>
      </Row>
      <DataIntegrationForm
        submitText={t('Create')}
        initialValues={{}}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </Container>
  );
};

export default NewDataIntegration;
